const ATTENDANCE_URLS = {
  INSERT: "/attendance/insert",
  GET_ALL: "/attendance/get_all_",
  GET_ALL_SELECT: "/attendance/get_all_select",
  STATUS_UPDATE: "/attendance/status_update",
  GET_ALL_MONTH: "/attendance/get_all_admin",
  GET_ALL_DAYS: "/attendance/get_all_days",
  GET_ONE: "/attendance/get_one_day",
  INSERT_DAY: "/attendance/insert_day",
  IMPORT_EXCEL: "/attendance/import_excel",
};

const SALARY_URLS = {
  INSERT: "/salary/insert",
  UPDATE: "/salary/insert",
  GET_ALL: "/salary/get_all",
  GET_ONE: "/salary/get_one",
  REFRESH: "/salary/refresh",
  STATUS_UPDATE: "/salary/status_update",
  SLIP_GET_ONE: "/salary/slip_get_one",
  SLIP_GET_EMP: "/salary/slip_get_emp",
  SLIP_GET_EMP_ONE: "/salary/slip_get_emp_one",
  EXPORT_EXCEL: "",
  SLIP_INSERT_SUB: "/salary/insert_sub",
  SLIP_CANCEL_SUB: "/salary/cancel_sub",
  SLIP_DELETE_SUB: "/salary/delete_sub",
};

const EMPLOYEE_URLS = {
  INSERT: "/employee/insert",
  UPDATE: "/employee/insert",
  GET_ALL: "/employee/get_all",
  GET_ONE: "/employee/get_one",
  GET_ALL_SELECT: "/employee/get_all_select",
  DELETE: "/employee/delete_one",
  STATUS_UPDATE: "/employee/status_update",
  DELETE_SALARY: "",
  ADMIN_PASS_RESET: "/employee/admin_pass_reset",
  GET_EXIT_DATA: "/employee/get_exit_data",
  UPDATE_EXIT: "/employee/update_exit",
  GET_ALL_SELECT_TEAM: "/employee/get_all_select_team",
  EMPLOYEE_GET_ONE: "/employee/get_one_user",
  PROFILE_UPDATE: "/employee/update_pass_profile_img",
  PROFILE_GET: "/user/get_one_image",
};

const EMPLOYEE_IMPORT_URL = {
  IMPORT_LEAVE: "/employee_import/leave",
  IMPORT_SALARY: "/employee_import/salary",
};

const PROJECTS_URLS = {
  INSERT: "/projects/insert",
  UPDATE: "/projects/update",
  GET_ALL: "/projects/get_all",
  GET_ONE: "/projects/get_one",
  GET_ALL_SELECT: "/projects/get_all_select",
  DELETE: "/projects/delete_one",
  STATUS_UPDATE: "",
  GET_ALL_SELECT_EMP: "/employee/get_all_select_emp",
  GET_ALL_SELECT_MAN: "projects/get_all_select_ename",
};
const EMPLOYEE_ASSETS_URLS = {
  INSERT: "/employee/insert_asset",
  UPDATE: "/employee/update_asset",
  GET_ALL: "/employee/get_all_assets",
  GET_ONE: "",
  DELETE: "/employee/remove_asset",
  GET_ALL_SELECT: "/admin_asset/get_all_select",
  STATUS_UPDATE: "",
};
const EMPLOYEE_DOC_URLS = {
  GET_ALL: "/employee/get_all_docs",
  INSERT: "/employee/insert_doc",
  UPDATE: "/employee/update_doc",
  GET_ONE: "/employee/get_one_doc",
  DOWNLOAD: "/employee/download_doc",
  DELETE: "/employee/remove_doc",
};
const EMPLOYEE_LEAVE_URLS = {
  INSERT: "/employee/insert_leave",
  UPDATE: "",
  GET_ALL: "/employee/get_all_leaves",
  GET_ONE: "/employee/get_one_leave",
  DELETE: "/employee/remove_leave",
  GET_LEAVE_HISTORY: "/employee/get_leave_history",
  GET_LEAVE_BALANCE: "/employee/get_leave_balance",
};
const EMPLOYEE_SALARY_URLS = {
  INSERT: "/employee/insert_salary ",
  UPDATE: "/employee/update_salary",
  GET_ALL: "/employee/get_all_salary",
  GET_ONE: "/employee/get_one_salary",
  DELETE: "/employee/remove_salary",
  GET_ALL_EMP_SALARY: "/employee/get_all_emp_salary",
};
const EMPLOYEE_BANK_URLS = {
  GET_ALL: "/employee/get_all_bank",
  INSERT: "/employee/insert_bank ",
  UPDATE: "/employee/update_bank",
  GET_ONE: "/employee/get_one_bank",
  DELETE: "/employee/remove_bank",
};

export {
  ATTENDANCE_URLS,
  EMPLOYEE_ASSETS_URLS,
  EMPLOYEE_BANK_URLS,
  EMPLOYEE_DOC_URLS,
  EMPLOYEE_IMPORT_URL,
  EMPLOYEE_LEAVE_URLS,
  EMPLOYEE_SALARY_URLS,
  EMPLOYEE_URLS,
  PROJECTS_URLS,
  SALARY_URLS
};

